export default [
	    {
	        "id": "screens__title",
	        "header": "Title",
	        "fieldName": "screens__title",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 150
	    },
	    {
	        "id": "screens__screen_type_id",
	        "header": "Screen Type",
	        "fieldName": "screen_types__name",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100,
	        "editField": "screens__screen_type_id"
	    },
	    {
	        "id": "screens__sort_order",
	        "header": "Sort Order",
	        "fieldName": "screens__sort_order",
	        "isSortable": true,
	        "isEditable": false,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "screens__track_engagement",
	        "header": "Track Engagement",
	        "fieldName": "screens__track_engagement",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "screens__json",
	        "header": "Json",
	        "fieldName": "screens__json",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "screens__parent_id",
	        "header": "Parent",
	        "fieldName": "screens__parent_id",
	        "isSortable": true,
	        "isEditable": false,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "screens__path",
	        "header": "Path",
	        "fieldName": "screens__path",
	        "isSortable": false,
	        "isEditable": false,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 150
	    }
	];